import { PartOrder } from 'app/models/PartOrder';
import type { OrderJson, OrderSource } from 'app/models/Order';

const KEWNET_ORDER_PATH = '/adminkew/goToOrder.php?id=';
const ODOO_ORDER_PATH = '/odoo/sales/';

export const getOrderUrlFromSource = (
  orderId: number,
  source?: OrderSource,
  odooSaleOrderId?: number,
): string => {
  if (source === 'odoo') {
    const saleOrderId = odooSaleOrderId ?? orderId;
    return `${import.meta.env.VITE_ODOO_URL}${ODOO_ORDER_PATH}${saleOrderId}`;
  }

  return `${import.meta.env.VITE_KEWNET_URL}${KEWNET_ORDER_PATH}${orderId}`;
};

export const getOrderUrlFromOrder = (order: OrderJson): string =>
  getOrderUrlFromSource(order.id, order.source, order.odooSaleOrderId);

export const getOrderUrlFromPartOrder = (partOrder: PartOrder): string =>
  getOrderUrlFromOrder(partOrder.order);
